import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { RouterLink } from 'src/routes/components';
// assets
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useRouter, useSearchParams } from 'src/routes/hooks';
import { useResetpasswordMutation } from "../../../store/Reducer/auth";
import { Box } from '@mui/material';


export default function JWTNewPasswordView() {

  const router = useRouter();
  const searchParams = useSearchParams();
  const email = searchParams.get('email');
  const code = searchParams.get('activation_code');
  const [resetpassword] = useResetpasswordMutation();
  const password = useBoolean();

  const NewPasswordSchema = Yup.object().shape({
    email: Yup.string().optional(),
    // password: Yup.string().optional(),
    password: Yup.string().min(8,
      'Password must be at least 8 characters long'
    ).required('Password is required'),
    // confirmPassword: Yup.string().optional(),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Confirm Password is required'),
    // otp: Yup.string().required('OTP is required'),
  });

  const defaultValues = {
    otp: '',
    email: '',
    password: '',
    confirmPassword: '',
  };

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(NewPasswordSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
    setValue,
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      const newData = { newpassword: data.password, confirmpassword: data.confirmPassword, email: data.email };
      let res = await resetpassword(newData).unwrap();
      toast.success(res?.message);
      router.push(paths.auth.jwt.login)
    } catch (error) {
      toast.error(error?.data?.message);
      console.error(error);
    }
  });

  useEffect(() => {
    email && setValue('email', email);
    code && setValue('otp', code);
  }, [email, code])


  const renderForm = (
    <Stack spacing={3} alignItems="center" >
      <RHFTextField
        name="email"
        label="Email"
        placeholder="example@gmail.com"
        InputLabelProps={{ shrink: true }}
        InputProps={{
          readOnly: true,
          sx: {
            pointerEvents: 'none',
            '&:hover fieldset': { borderColor: 'transparent !important' },
            '&.Mui-focused fieldset': { borderColor: 'transparent !important' },
            backgroundColor: 'background.paper',
          },
        }}
      />
      <Box sx={{ display: "grid", gap: 2, width: "100%", gridTemplateColumns: { xs: "1fr", sm: "1fr" } }}>
        <RHFTextField
          name="password"
          label="Password"
          type={password.value ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={password.onToggle} edge="end">
                  <Iconify icon={password.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <RHFTextField
          name="confirmPassword"
          label="Confirm New Password"
          type={password.value ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={password.onToggle} edge="end">
                  <Iconify icon={password.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        color="primary"
        variant="contained"
        loading={isSubmitting}
      >
        Update Password
      </LoadingButton>

      <Link
        component={RouterLink}
        href={paths.auth.jwt.login}
        color="inherit"
        variant="subtitle2"
        sx={{
          alignItems: 'center',
          display: 'inline-flex',
        }}
      >
        <Iconify icon="eva:arrow-ios-back-fill" width={16} />
        Return to sign in
      </Link>
    </Stack>
  );

  const renderHead = (
    <>
      <Stack spacing={1} sx={{ my: 5 }}>
        <Typography variant="h3">Reset Your Password</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Enter and confirm your new password.
        </Typography>
      </Stack>
    </>
  );

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      {renderHead}
      {renderForm}
    </FormProvider>
  );
}
